import { getMeta } from './main';

export const showError = (input, message) => {
    // get the form-field element
    const formField = input.parentElement;
    // add the error class
    formField.classList.add('b-error');

    // show the error message
    const error = formField.querySelector('small');
    error.textContent = message;
};

const locale = getMeta('locale');

export const removeError = (input) => {
    // get the form-field element
    const formField = input.parentElement;
    // remove the error class
    formField.classList.remove('b-error');
    // show the error message
    const error = formField.querySelector('small');
    error.textContent = '';
};

export const isRequired = value => value !== '';

export const isBetween = (length, min, max) => !(length < min || length > max);

export const maxChartersLength = (length, max) => !(length > max);

export const isEqualCount = (length, value) => !(length !== value);

export const isEmailValid = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};

export const hasHtmlTags = (value = '') => /[<>]/.test(value);

export const checkUsername = (input, isErrorCheck = true, maxLength) => {
    let valid = false;
    const username = input.value.trim();

    if (!isRequired(username)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'This field is required' : 'Ce champ est obligatoire');
        }
    } else if (hasHtmlTags(username)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'HTML tags are not allowed' : 'Les balises HTML ne sont pas autorisées');
        }
    } else if (!maxChartersLength(username.length, maxLength)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? `Must be less than or equal to ${maxLength}` : `Doit être inférieur ou égal à ${maxLength}`);
        }
    } else {
        removeError(input);
        valid = true;
    }

    return valid;
};

export const checkCompany = (input, isErrorCheck = true, maxLength) => {

    let valid = false;
    const companyname = input.value.trim();
    if (!isRequired(companyname)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'This field is required' : 'Ce champ est obligatoire');
        }
    } else if (!maxChartersLength(companyname.length, maxLength)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? `Must be less than or equal to ${maxLength}` : `Doit être inférieur ou égal à ${maxLength}`);
        }
    } else {
        removeError(input);
        valid = true;
    }
    return valid;
}

export const checkDefaultValidation = (input, isErrorCheck = true, maxLength) => {

    let valid = false;
    const value = input.value.trim();
    if (!isRequired(value)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'This field is required' : 'Ce champ est obligatoire');
        }
    } else if (!maxChartersLength(value.length, maxLength)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? `Must be less than or equal to ${maxLength}` : `Doit être inférieur ou égal à ${maxLength}`);
        }
    } else {
        removeError(input);
        valid = true;
    }
    return valid;
}

export const checkEmail = (input, isErrorCheck = true, maxLength, otherField, isBranchAccount, isServerRequestError) => {
    let valid = false;
    const email = input.value.trim();

    if (otherField) {
        if (!email && !otherField.value) {
            showError(input, locale === 'en' ? 'Phone or email must be filled in' : 'Le téléphone ou l\'email doit être renseigné');
            return true;
        } else if (!email) {
            removeError(input);
            return true;
        }
    }

    if (isServerRequestError) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'Email is not valid' : 'L\'email n\'est pas valide')
        }
    } else if (!isRequired(email)) {
        if (isErrorCheck) {
            isBranchAccount ?
                showError(input, locale === 'en' ? 'Required. If you don\'t have an email, contact the branch' : 'Requis. Si vous n\'avez pas d\'email, contactez l\'agence') :
                showError(input, locale === 'en' ? 'This field is required' : 'Ce champ est obligatoire');
        }
    } else if (!isEmailValid(email)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'Email is not valid' : 'L\'email n\'est pas valide')
        }
    } else if (!maxChartersLength(email.length, maxLength)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? `Must be less than or equal to ${maxLength}` : `Doit être inférieur ou égal à ${maxLength}`);
        }
    } else {
        removeError(input);
        valid = true;
    }
    return valid;
}

export const checkNotes = (input, isErrorCheck = true, maxLength) => {
    let valid = false;
    const notes = input.value.trim();
    if (!maxChartersLength(notes.length, maxLength)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? `Must be less than or equal to ${maxLength}` : `Doit être inférieur ou égal à ${maxLength}`);
        }
    } else {
        removeError(input);
        valid = true;
    }
    return valid;
}

export const checkPhone = (input, isErrorCheck = true, maxLength, otherField, isBranchAccount, isAccountInternational) => {
    let valid = false;
    const lengthEqualCount = isAccountInternational ? 9 : 10;
    const phone = input.value.trim();
    const phoneCode = phone.slice(0, 2);
    const phoneWithoutCode = phone.slice(-8);
    const allowCodeList = ["01", "02", "03", "04", "05", "06", "07"];
    const forbiddenList = [
        "12345678",
        "23456789",
        "34567891",
        "45678912",
        "56789123",
        "67891234",
        "98765432",
        "01010101",
        "02020202",
        "03030303",
        "04040404",
        "05050505",
        "06060606",
        "07070707",
        "08080808",
        "09090909",
        "00000000",
        "11111111",
        "22222222",
        "33333333",
        "44444444",
        "55555555",
        "66666666",
        "77777777",
        "88888888",
        "99999999"
    ];

    if (isAccountInternational && phone.startsWith('0')) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'The phone number should not start with 0' : 'Le numéro de téléphone ne doit pas commencer par 0');
            return false;
        }
    }

    if (otherField) {
        if (!phone && !otherField.value) {
            showError(input, locale === 'en' ? 'Phone or email must be filled in' : 'Le téléphone ou l\'email doit être renseigné');
            return true;
        } else if (!phone) {
            removeError(input);
            return true;
        }
    }

    if (isBranchAccount && !allowCodeList.some(code => code === phoneCode)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'This phone number is not accepted' : 'Ce numéro n\'est pas accepté');
        }
    } else if (isBranchAccount && forbiddenList.some(phone => phone.toString() === phoneWithoutCode)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'This phone number is not accepted' : 'Ce numéro n\'est pas accepté');
        }
    } else if (!isRequired(phone)) {
        if (isErrorCheck) {
            isBranchAccount ?
                showError(input, locale === 'en' ? 'Required. If you don\'t have a phone, contact the branch' : 'Requis. Si vous n\'avez pas de téléphone, contactez l\'agence') :
                showError(input, locale === 'en' ? 'This field is required' : 'Ce champ est obligatoire');
        }
    } else if (!isEqualCount(phone.length, lengthEqualCount)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? `Phone number should have ${lengthEqualCount} characters` : `Le numéro doit comporter ${lengthEqualCount} chiffres`);
        }
    } else if (!maxChartersLength(phone.length, maxLength)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? `Must be less than or equal to ${maxLength}` : `Doit être inférieur ou égal à ${maxLength}`);
        }
    } else {
        removeError(input);
        valid = true;
    }
    return valid;
};

export const checkBirthDate = (input, isErrorCheck = true) => {
    let valid = false;
    const TEMPLATE = '__-__-____';
    const value = input.value.trim();
    const currentYear = new Date().getFullYear();

    const formatValid = /^\d{2}-\d{2}-\d{4}$/.test(value);
    if (!isRequired(value) || value === TEMPLATE) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'This field is required' : 'Ce champ est obligatoire');
        }
    } else if (!formatValid) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'Date must be in DD-MM-YYYY format' : 'La date doit être au format JJ-MM-AAAA');
        }
    } else {
        const [dd, mm, yyyy] = value.split('-').map(Number);

        if (mm < 1 || mm > 12) {
            if (isErrorCheck) {
                showError(input, locale === 'en' ? 'Invalid month' : 'Mois invalide');
            }
            return false;
        }

        if (yyyy < 1900 || yyyy > currentYear) {
            if (isErrorCheck) {
                showError(input, locale === 'en' ? `Year must be between 1900 and ${currentYear}` : `L'année doit être comprise entre 1900 et ${currentYear}`);
            }
            return false;
        }

        const daysInMonth = new Date(yyyy, mm, 0).getDate(); // 0 = last day of previous month
        if (dd < 1 || dd > daysInMonth) {
            if (isErrorCheck) {
                showError(input, locale === 'en'
                  ? `Invalid day for month ${String(mm).padStart(2, '0')}`
                  : `Jour invalide pour le mois ${String(mm).padStart(2, '0')}`);
            }
            return false;
        }

        removeError(input);
        valid = true;

        const hidden = document.getElementById('hidden-birth-date') || document.getElementById('hidden_date_of_birth');
        if (hidden) {
            hidden.value = `${yyyy}-${String(mm).padStart(2, '0')}-${String(dd).padStart(2, '0')}`;
        }
    }
    return valid;
};

export const checkPostCode = (input, isErrorCheck = true, validationCodeLength = 5, noPostCode = false) => {
    let valid = false;
    const code = input.value.trim();
    const lengthEqualCount = validationCodeLength;

    if (noPostCode) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'Post code not detected, please add it' : 'Code postal non détecté, veuillez l\'ajouter');
        }
    } else if (!isRequired(code)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? 'This field is required' : 'Ce champ est obligatoire');
        }
    } else if (!isEqualCount(code.length, lengthEqualCount)) {
        if (isErrorCheck) {
            showError(input, locale === 'en' ? `Must contain ${lengthEqualCount} characters.` : `Doit contenir ${lengthEqualCount} caractères.`);
        }
    } else {
        removeError(input);
        valid = true;
    }
    return valid;
}
